(function () {
  "use strict";

  function isBad(a) {
    var raw = a.getAttribute("href");
    if (!raw) return false;
    if (raw === "undefined" || raw === "null") return true;
    var path;
    try {
      path = new URL(a.href, window.location.origin).pathname;
    } catch (e) {
      return false;
    }
    return /\/(undefined|null)\/?$/.test(path);
  }

  function neutralize(a) {
    a.removeAttribute("href");
    a.setAttribute("data-no-prerender", "");
    a.setAttribute("aria-disabled", "true");
    a.setAttribute("data-au-bad-link", "");
  }

  function sweep(root) {
    var links = (root || document).querySelectorAll
      ? (root || document).querySelectorAll("a[href]")
      : [];
    for (var i = 0; i < links.length; i++) {
      if (isBad(links[i])) neutralize(links[i]);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var a = e.target && e.target.closest && e.target.closest("a[href]");
      if (a && isBad(a)) {
        e.preventDefault();
        e.stopPropagation();
        neutralize(a);
      }
    },
    true
  );

  function start() {
    sweep(document);
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === "attributes") {
          if (r.target.nodeType === 1 && r.target.matches("a[href]") && isBad(r.target)) neutralize(r.target);
          continue;
        }
        var added = r.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches("a[href]") && isBad(n)) neutralize(n);
          if (n.querySelectorAll) sweep(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["href"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
